module.exports = __webpack_public_path__ + "img/vertical_7_5_9016.792352d0.png";